import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CardLayout from '@/components/Layout/CardLayout';
import Button from '@/components/ui/Button';
import PrimaryInput from '@/components/ui/PrimaryInput';
import { IDeleteResponse } from '@/interfaces/common.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Modal } from 'reactstrap';
export interface IAddDepartmentForm {
  id: string;
  name: string;
  isActive?: boolean;
  index?: number;
  toggleStatus?: boolean;
}
interface IAddDepartmentModalProps {
  isOpen: boolean;
  EditData: IAddDepartmentForm | null;
  onClose: () => void;
  getDepartment?: () => void;
}

const AddDepartmentModal = ({
  isOpen,
  EditData,
  onClose,
  getDepartment,
}: IAddDepartmentModalProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<IAddDepartmentForm>();

  useEffect(() => {
    if (EditData) {
      setValue('name', EditData?.name);
      setValue('isActive', EditData?.toggleStatus ?? EditData?.isActive);
    } else {
      reset();
    }
  }, [EditData]);
  const onSubmit: SubmitHandler<IAddDepartmentForm> = async (data) => {
    setIsLoading(true);
    const submitData = {
      ...data,
      isActive: EditData
        ? (EditData?.toggleStatus ?? EditData?.isActive)
        : true,
    };
    try {
      const API =
        EditData !== null
          ? API_URL +
          API_ENDPOINT?.updateDepartment +
          `?departmentId=${EditData?.id}`
          : API_URL + API_ENDPOINT?.addDepartment;
      const response: IDeleteResponse = await callApi(API, {
        method: 'POST',
        data: submitData,
      });
      setIsLoading(false);
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        if (getDepartment) {
          getDepartment();
        }
        onClose();
        reset();
      } else {
        showToastNotification('danger', response?.message);
        reset();
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Modal
      className="modal-dialog modal-dialog-centered modal-md"
      isOpen={isOpen}
    >
      <div className="modal-content shadow-lg">
        <div className="modal-header p-4">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="addHolidayModalLabel"
          >
            {EditData ? 'Edit' : 'Add'} Department
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              clearErrors();
              onClose();
              reset();
            }}
          />
        </div>
        <div className="modal-body p-4">
          <form onSubmit={handleSubmit(onSubmit)}>
            <CardLayout cardStyle="shadow-none mb-0">
              <div className="row">
                <div className="col-12">
                  <div className="form-group mb-3">
                    <PrimaryInput
                      label="Department Name"
                      type="text"
                      id="departName"
                      placeholder="Enter department Name"
                      required={true}
                      {...register('name', {
                        ...errorTypes.required(),
                        ...errorTypes.capitalName,
                      })}
                      errors={errors?.name?.message}
                    />
                  </div>
                </div>
              </div>
            </CardLayout>
            <div className="modal-footer p-2">
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  clearErrors();
                  onClose();
                  reset();
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="btn btn-primary"
                isLoading={isLoading}
              >
                {EditData ? 'Edit Department' : 'Add Department'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AddDepartmentModal;
